import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PUBLIC_SERVICE_PAGES, servicePath } from '@/lib/publicServicePages';

const ORIGIN = 'https://www.cainversionesservicios.com';
export const PUBLIC_PAGES = {
  ...Object.fromEntries(PUBLIC_SERVICE_PAGES.map(page => [servicePath(page), [page.title, page.description]])),
  '/': ['Grúa y asistencia vial en San Cristóbal y Santo Domingo | C&A', 'Grúa plataforma, asistencia vial y traslado de vehículos en San Cristóbal y Santo Domingo. Consulta disponibilidad y condiciones con C&A Transporte & Rescate.'],
  '/flota': ['Nuestra flota | C&A Transporte & Rescate', 'Conoce las unidades de grúa, rescate y transporte de C&A en República Dominicana.'],
  '/solicitar': ['Solicitar asistencia | C&A Transporte & Rescate', 'Solicita asistencia vial, grúa, batería, neumáticos o combustible y consulta el estado de tu servicio.'],
  '/contact': ['Contacto | C&A Transporte & Rescate', 'Contacta a C&A Transporte & Rescate para asistencia vial y servicios de grúa en República Dominicana.'],
  '/privacy': ['Política de privacidad | C&A Transporte & Rescate', 'Conoce cómo C&A trata y protege los datos de clientes y colaboradores.'],
  '/terms': ['Términos y condiciones | C&A Transporte & Rescate', 'Consulta las condiciones de asistencia vial, grúa, seguimiento y comunicaciones de C&A.'],
};
export const CANONICAL_ALIAS = { '/website': '/', '/privacy-policy': '/privacy', '/terms-and-conditions': '/terms' };

function meta(name, value) {
  let node = document.head.querySelector(`meta[name="${name}"]`);
  if (!node) { node = document.createElement('meta'); node.name = name; document.head.appendChild(node); }
  node.content = value;
}

export default function SiteMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const canonical = CANONICAL_ALIAS[pathname] || pathname;
    const page = PUBLIC_PAGES[canonical];
    document.title = page?.[0] || 'C&A Transporte & Rescate | Área privada';
    meta('description', page?.[1] || 'Portal de C&A Transporte & Rescate.');
    meta('robots', page && canonical === pathname ? 'index,follow' : 'noindex,nofollow');
    for (const [property, content] of Object.entries({
      'og:title': document.title, 'og:description': page?.[1] || 'Portal de C&A Transporte & Rescate.',
      'og:url': page ? `${ORIGIN}${canonical}` : ORIGIN,
    })) {
      let node = document.head.querySelector(`meta[property="${property}"]`);
      if (!node) { node = document.createElement('meta'); node.setAttribute('property', property); document.head.appendChild(node); }
      node.content = content;
    }
    meta('twitter:title', document.title);
    meta('twitter:description', page?.[1] || 'Portal de C&A Transporte & Rescate.');
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    if (page) link.href = `${ORIGIN}${canonical}`;
    else link.removeAttribute('href');
  }, [pathname]);
  return null;
}

